"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LeaderboardBody = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var component_1 = __importDefault(require("@loadable/component"));
var clsx_1 = __importDefault(require("clsx"));
var react_1 = require("react");
var useMoneyFormatter_1 = require("../../hooks/useMoneyFormatter");
var helpers_1 = require("../../utilities/helpers");
var LeaderboardBodyData = (0, component_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("./LeaderboardBodyData")); })];
        case 1: return [2 /*return*/, (_a.sent()).LeaderboardBodyData];
    }
}); }); });
var LeaderboardBodyRow = (0, component_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("./LeaderboardBodyRow")); })];
        case 1: return [2 /*return*/, (_a.sent()).LeaderboardBodyRow];
    }
}); }); });
var LeaderboardFooter = (0, component_1.default)(function () { return __awaiter(void 0, void 0, void 0, function () { return __generator(this, function (_a) {
    switch (_a.label) {
        case 0: return [4 /*yield*/, Promise.resolve().then(function () { return __importStar(require("./LeaderboardFooter")); })];
        case 1: return [2 /*return*/, (_a.sent()).LeaderboardFooter];
    }
}); }); });
var LeaderboardBody = function (_a) {
    var _b;
    var columns = _a.columns, data = _a.data, renderRow = _a.renderRow, renderHeader = _a.renderHeader, renderHeaderRow = _a.renderHeaderRow, renderFooter = _a.renderFooter, isRaceActive = _a.isRaceActive, currency = _a.currency;
    var moneyFormat = (0, useMoneyFormatter_1.useMoneyFormatter)().moneyFormat;
    var _c = (0, react_1.useState)(false), listExpanded = _c[0], setListExpanded = _c[1];
    var bodyRef = (0, react_1.useRef)(null);
    var toggleList = (0, react_1.useCallback)(function () {
        setListExpanded(function (toggled) {
            var _a;
            if (!toggled === false) {
                (_a = bodyRef.current) === null || _a === void 0 ? void 0 : _a.scrollTo({ top: 0, behavior: "smooth" });
            }
            return !toggled;
        });
    }, []);
    var renderPrize = function (prize) {
        if (prize) {
            return moneyFormat(prize, currency);
        }
        return "-";
    };
    var renderEvolution = function (evolution) {
        if (evolution === 0) {
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-body--content-evolution" }, { children: [(0, jsx_runtime_1.jsx)("div", { className: "leaderboard-body--content-evolution--neutral" }), "0"] })));
        }
        if (evolution > 0) {
            return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-body--content-evolution" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--content-evolution--positive" }, { children: "\u25B2" })), "+", evolution] })));
        }
        return ((0, jsx_runtime_1.jsxs)("div", __assign({ className: "leaderboard-body--content-evolution" }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--content-evolution--negative" }, { children: "\u25BC" })), evolution] })));
    };
    var usedColumns = (0, react_1.useMemo)(function () {
        if (!columns) {
            return [
                {
                    title: "Rank",
                },
                {
                    title: "User Id",
                },
                {
                    title: "Points",
                },
                {
                    title: "Prize",
                },
                {
                    title: "Evolution",
                },
            ];
        }
        return columns;
    }, [columns]);
    return ((0, jsx_runtime_1.jsxs)("div", __assign({ ref: bodyRef, className: (0, clsx_1.default)("leaderboard-body", listExpanded && "leaderboard-body--expanded") }, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--header" }, { children: renderHeader ? renderHeader(usedColumns) : (0, jsx_runtime_1.jsx)(LeaderboardBodyRow, { children: usedColumns.map(function (item, idx) { return (renderHeaderRow ? renderHeaderRow(item) : (0, jsx_runtime_1.jsx)(LeaderboardBodyData, { children: item.title }, idx)); }) }) })), ((_b = data === null || data === void 0 ? void 0 : data.players) === null || _b === void 0 ? void 0 : _b.length) > 0 && (0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsx)("div", __assign({ className: "leaderboard-body--content" }, { children: data.players.map(function (player, idx) { return renderRow ? renderRow(player) : ((0, jsx_runtime_1.jsxs)(LeaderboardBodyRow, __assign({ toggleList: toggleList, code: data.code, player: player }, { children: [(0, jsx_runtime_1.jsx)(LeaderboardBodyData, { children: idx + 1 }), (0, jsx_runtime_1.jsx)(LeaderboardBodyData, { children: (0, helpers_1.beautifyUserId)(player.username, player.isYou) }), (0, jsx_runtime_1.jsx)(LeaderboardBodyData, { children: moneyFormat(player.points) }), (0, jsx_runtime_1.jsx)(LeaderboardBodyData, { children: renderPrize(player.prizeAmount) }), (0, jsx_runtime_1.jsx)(LeaderboardBodyData, { children: renderEvolution(player.evolution) })] }), idx)); }) })), renderFooter ? renderFooter(toggleList, isRaceActive) : !isRaceActive &&
                        (0, jsx_runtime_1.jsx)(LeaderboardFooter, { collapsed: listExpanded, toggleList: toggleList })] })] })));
};
exports.LeaderboardBody = LeaderboardBody;
